<template>
  <div class="showcase-home-hero-register">
    <div class="header">
      <div class="title">
        {{ currentStep.title }}
      </div>
      <div class="status">{{ statusText }}</div>
    </div>
    <div class="content">
      <TextField
        class="white outline transparent blur big"
        v-model="name"
        placeholder="注册的用户"
      />
      <TextField
        class="white outline transparent blur big"
        v-model="password"
        type="password"
        placeholder="设置的密码"
      />
      <div class="action">
        <button
          class="button outline white transparent blur big block"
          @click="onClickActionButton"
        >
          {{ actionButtonText }}
        </button>
      </div>
    </div>
    <div class="footer">
      <div class="invite-status">
        <div class="icon">
          <AppIcon :name="inviteStatusIcon" color="#fff" :size="16" />
        </div>
        <div class="text">
          {{ inviteStatusText }}
        </div>
      </div>
      <div class="action" v-if="showAction">
        <button class="button basic" @click="onClickBackButton">
          {{ actionText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import TextField from '@/app/components/text-field';
import AppIcon from '@/app/components/app-icon';

export default defineComponent({
  name: 'ShowcaseHomeHeroRegister',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      defaultStatusText: '路未尽、行不止。',
      statusText: '路未尽、行不止。',
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      currentStepName: 'invite/currentStepName',
      currentStep: 'invite/currentStep',
      inviteCode: 'invite/validate/inviteCode',
      isValidInviteCode: 'invite/validate/isValidInviteCode',
      _name: 'invite/register/name',
      _password: 'invite/register/password',
    }),

    name: {
      get() {
        return this._name;
      },
      set(data) {
        if (this.statusText !== this.defaultStatusText) {
          this.statusText = this.defaultStatusText;
        }
        this.setName(data);
      },
    },

    password: {
      get() {
        return this._password;
      },
      set(data) {
        if (this.statusText !== this.defaultStatusText) {
          this.statusText = this.defaultStatusText;
        }
        this.setPassword(data);
      },
    },

    actionButtonText() {
      return '注册新用户';
    },

    inviteIcon() {
      let icon = {
        name: this.isValidInviteCode ? 'verified' : 'error_outline',
      };

      return icon;
    },

    inviteStatusIcon() {
      return this.isValidInviteCode ? 'check_circle' : 'error_outline';
    },

    inviteStatusText() {
      return this.isValidInviteCode ? '通过验证邀请' : '未通过验证邀请';
    },

    actionText() {
      return '← 点击重新验证';
    },

    showAction() {
      return !this.isValidInviteCode;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentStepName: 'invite/setCurrentStepName',
      setName: 'invite/register/setName',
      setPassword: 'invite/register/setPassword',
    }),

    ...mapActions({
      validateInvite: 'invite/validate/validateInvite',
      inviteRegister: 'invite/register/inviteRegister',
      // pushMessage: 'notification/pushMessage',
    }),

    async onClickActionButton() {
      if (!this.isValidInviteCode) {
        return (this.statusText = '邀请没有验证通过，请重新验证邀请。');
      }

      if (!this.name) {
        return (this.statusText = '请输入要注册的用户名。');
      }

      if (!this.password) {
        return (this.statusText = '请输入设置的用户密码。');
      }

      try {
        await this.inviteRegister({
          name: this.name,
          password: this.password,
          inviteCode: this.inviteCode,
        });

        this.setCurrentStepName('complete');
      } catch (error) {
        //
        if (error.data && Array.isArray(error.data.message)) {
          this.statusText = error.data.message[0];
        }

        if (
          error.data &&
          !Array.isArray(error.data.message) &&
          error.data.message
        ) {
          this.statusText = error.data.message;
        }
      }
    },

    onClickBackButton() {
      this.setCurrentStepName('validate');
    },
  },

  /**
   * 使用组件
   */
  components: {
    AppIcon,
    TextField,
  },
});
</script>

<style scoped>
@import './styles/showcase-home-hero-register.css';
</style>
